import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Alert, Card, Typography, Snackbar, Button, Sheet, IconButton, Grid, Dropdown, MenuButton, Menu, MenuItem, Divider } from '@mui/joy';
import { Modal, ModalDialog, ModalClose, DialogTitle, DialogContent, ModalOverflow } from '@mui/joy';
import { Switch, CardActions, CardContent } from '@mui/joy';
import { Report, Check, ContentCopy, MoreVert, ExpandLess, ExpandMore } from '@mui/icons-material';
import { cardStyles } from '../../styles/cardStyles';
import { useAuth } from '../../context/authContext';

import LoadingSpinnerComponent from '../LoadingSpinnerComponent';
import StageComponent from './StageComponent';
import ManageStageComponent from './ManageStageComponent';
import EmptyMessageComponent from '../EmptyMessageComponent';
import RealtimePreview from './RealtimePreview';

import '../../styles/typography.scss';
import '../../styles/navigation.scss';
import '../../styles/stage.scss';

const networking = require('../../Networking/API');
const authNetworking = require('../../Networking/AuthenticationAPI');
const helpers = require('../../Helpers/helpers');

function FeedbackComponent(app: any) {
    const { token } = useAuth();

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [showError, setShowError] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [success, setSuccess] = useState('');
    const [stages, setStages] = useState(null) as any[];
    const [addNew, setAddNew] = useState(false);
    const [showPreview, setShowPreview] = useState(false);
    const [showReviews, setShowReviews] = useState(false);
    const [selectedStage, setSelectedStage] = useState(null) as any;
    const [stagePrompts, setStagePrompts] = useState({}) as any;
    const [configs, setConfigs] = useState(null) as any;
    const [configExpanded, setConfigExpanded] = useState(false);

    let list = null;

    useEffect(() => {
        getData();
        getConfigs();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (error !== '') {
            setShowError(true);
        }
    }, [error]);

    function getData() {
        networking.getStages(token, app.app.id).then((stages: any) => {
            stages.sort((a: any, b: any) => new Date(b.creation_date).getTime() - new Date(a.creation_date).getTime());
            setStages(stages);
            // Buscar prompts para cada stage
            stages.forEach((stage: any) => {
                getTotalPromptsForStage(stage.id);
            });
            setLoading(false);
        }).catch((error: Error) => {
            setError(error.message);
            setLoading(false);
        });
    }

    function getConfigs() {
        authNetworking.getKeysForSubscription(token, app.subscription.id).then((config: any) => {
            setLoading(false);
            setConfigs(config);
            updateConfigs();
        }).catch((error: Error) => {
            setError(error.message);
            setLoading(false);
        });
    }

    function updateConfigs() {
        authNetworking.updateKeysForSubscription(token, app.subscription.id).then((config: any) => {
        }).catch((error: Error) => {
        });
    }

    function addNewStage(open: boolean) {
        setAddNew(open)
    }

    const didAddNewStage = (event: any) => {
        setSuccess('Your new stage was added and is active.');
        setShowSuccess(true);
        setAddNew(false);
        getData();
    };

    function removeStage(stage: any) {
        setLoading(true);

        networking.deleteStage(token, stage.id).then((stage: any) => {
            setLoading(false);
            setSuccess('Stage removed.');
            setShowSuccess(true);
            getData();
        }).catch((error: Error) => {
            setLoading(false);
            setError(error.message);
        });
    }

    function openPreview(stage: any) {
        setSelectedStage(stage);
        setShowPreview(true);
    }

    const updateStatus = (stage: any, e: any) => {
        setLoading(true);
        let status = e.target.checked ? 'active' : 'inactive';

        networking.updateStage(token, stage.id, status).then((stages: any) => {
            setLoading(false);
            setSuccess('Your moment is ' + status + '.');
            setShowSuccess(true);
            getData();
        }).catch((error: Error) => {
            setError(error.message);
            setLoading(false);
        });
    }

    function copyToClipboard(value: string, name: string) {
        navigator.clipboard.writeText(value);
        setShowSuccess(true);
        setSuccess(`${name} copied to clipboard.`);
    }

    function showStageReviews(stage: any) {
        setSelectedStage(stage);
        setShowReviews(true);
    }

    function getTotalPromptsForStage(stageId: string) {
        networking.getQueriesForStage(token, stageId).then((results: any) => {
            const total = results ? results.length : 0;
            setStagePrompts((prev: any) => ({
                ...prev,
                [stageId]: total
            }));
        }).catch((error: Error) => {
            console.error(`Error fetching prompts for stage ${stageId}:`, error);
            setStagePrompts((prev: any) => ({
                ...prev,
                [stageId]: 0
            }));
        });
    }

    function getTotalPrompts(stageId: string) {
        return stagePrompts[stageId] || 0;
    }

    if (stages) {
        list = (
            <Grid container spacing={2} sx={{ mt: 2 }}>
                {stages.map((stage: any, index: number) => (
                    <Grid xs={12} sm={6} md={3} key={index}>
                        <Card
                            color="neutral"
                            orientation="vertical"
                            size="lg"
                            variant="outlined"
                            sx={{
                                marginTop: 2,
                                ...cardStyles.base,
                                padding: 0
                            }}>
                            <CardContent
                                sx={{ flexGrow: 1, padding: '16px 16px 0px 16px' }}>
                                <div className='row mb-1'>
                                    <div className='col my-auto'>
                                        <Typography
                                            level="title-md"
                                            sx={{ mb: 1 }}
                                            className="d-flex align-items-center gap-2 my-auto">
                                            {stage.name}
                                        </Typography>
                                    </div>
                                    <div className='col-auto my-auto'>
                                        <Dropdown>
                                            <MenuButton
                                                variant="plain"
                                                color="neutral">
                                                <MoreVert />
                                            </MenuButton>
                                            <Menu placement="bottom-end">
                                                {getTotalPrompts(stage.id) === 0 ? null :
                                                    <MenuItem
                                                        onClick={() => showStageReviews(stage)}
                                                        sx={{
                                                            fontSize: 12
                                                        }}>
                                                        Show Report
                                                    </MenuItem>
                                                }
                                                <MenuItem
                                                    color="danger"
                                                    onClick={() => removeStage(stage)}
                                                    sx={{
                                                        fontSize: 12
                                                    }}>
                                                    Delete Stage
                                                </MenuItem>
                                                <MenuItem
                                                    color="primary"
                                                    onClick={() => openPreview(stage)}
                                                    sx={{
                                                        fontSize: 12
                                                    }}>
                                                    See preview
                                                </MenuItem>
                                            </Menu>
                                        </Dropdown>
                                    </div>
                                </div>

                                <Typography level="body-xs" sx={{ mb: 1 }}>
                                    <span className='bold'>Created:</span> {helpers.formatFriendlyDate(new Date(stage.creation_date), navigator.language)}
                                </Typography>

                                <Typography level="body-xs" sx={{ mb: 2 }}>
                                    {getTotalPrompts(stage.id) === 0 ? "No" : <b>{getTotalPrompts(stage.id)}</b>} moments presented.
                                </Typography>
                            </CardContent>

                            <CardActions sx={{ justifyContent: 'space-between', pt: 0, backgroundColor: '#f9f9f9', padding: '12px', borderRadius: '0 0 12px 12px' }}>
                                <Switch
                                    size="sm"
                                    checked={stage.status === 'active'}
                                    onChange={(event) => updateStatus(stage, event)}
                                />
                                {stage.status === 'active' ?
                                    <Typography level="body-xs" color="success">
                                        Active
                                    </Typography>
                                    :
                                    <Typography level="body-xs" color="danger">
                                        Inactive
                                    </Typography>
                                }
                            </CardActions>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        );
    }

    return (
        <div className=''>
            {showError &&
                <Snackbar
                    variant="soft"
                    color="danger"
                    open={showError}
                    onClose={() => setShowError(false)}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    startDecorator={<Report />}
                    endDecorator={
                        <Button
                            onClick={() => setShowError(false)}
                            size="sm"
                            variant="soft"
                            color="danger"
                        >
                            Dismiss
                        </Button>
                    }
                >
                    {error}
                </Snackbar>
            }
            {showSuccess &&
                <Snackbar
                    variant="soft"
                    color="success"
                    open={showSuccess}
                    onClose={() => setShowSuccess(false)}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    startDecorator={<Check />}
                    autoHideDuration={2000}
                    endDecorator={
                        <Button
                            onClick={() => setShowSuccess(false)}
                            size="sm"
                            variant="soft"
                            color="success"
                        >
                            Dismiss
                        </Button>
                    }
                >
                    {success}
                </Snackbar>
            }
            {/* Page Banner */}
            <Alert
                className="mb-3"
                size="lg"
                variant="soft"
                color="neutral"
                endDecorator={
                    <Button
                        color='primary'
                        size='sm'
                        variant='solid'
                        onClick={() => addNewStage(true)}
                    >
                        Add new moment
                    </Button>
                }>
                <div>
                    <div>
                        <Typography level="title-md">
                            Proactive feedback
                        </Typography>
                    </div>
                    <Typography level="body-sm">
                        Here you can manage your Proactive feedback stages.
                    </Typography>
                </div>
            </Alert>

            {/* Stage creation Modal */}
            <Modal
                open={addNew}
                onClose={() => setAddNew(false)}>
                <ModalOverflow>
                    <ModalDialog
                        color="neutral"
                        layout="center"
                        size="sm"
                        variant="plain"
                        minWidth={800}
                        maxWidth={'90vw'}
                        sx={{
                            width: '90vw',
                            maxHeight: '90vh'
                        }}>
                        <ModalClose />
                        <>
                            <ManageStageComponent
                                app={app.app}
                                handler={didAddNewStage}
                            />
                        </>
                    </ModalDialog>
                </ModalOverflow>
            </Modal>

            {/* Stage report Modal */}
            <Modal
                open={showReviews}
                onClose={() => setShowReviews(false)}>
                <ModalOverflow>
                    <ModalDialog
                        color="neutral"
                        layout="center"
                        size="sm"
                        variant="plain"
                        minWidth={800}
                        maxWidth={'90vw'}
                        sx={{
                            width: '90vw',
                            maxHeight: '90vh'
                        }}>
                        <ModalClose />
                        <DialogTitle>
                            Moment Report
                        </DialogTitle>
                        <DialogContent>
                            View feedback reports for this moment.
                        </DialogContent>
                        <Divider />
                        {selectedStage && (
                            <StageComponent
                                app={app.app.id}
                                stage={selectedStage}
                                onRemoveStage={removeStage}
                            />
                        )}
                    </ModalDialog>
                </ModalOverflow>
            </Modal>

            {/* Stage Preview  Modal */}
            <Modal
                open={showPreview}
                onClose={() => setShowPreview(false)}>
                <ModalOverflow>
                    <ModalDialog
                        color="neutral"
                        layout="center"
                        size="sm"
                        variant="plain">
                        <ModalClose />
                        <>
                            <Typography level="title-sm">
                                Stage Preview
                            </Typography>
                            <Typography level="body-sm" sx={{ mb: 2 }}>
                                This is how your moment will look like in your app.
                            </Typography>
                            {/* Aqui vai o componente de preview em tempo real */}
                            <div className='d-flex justify-content-center'>
                                <RealtimePreview
                                    type={selectedStage ? selectedStage.type : 'default'}
                                    questionType={selectedStage ? selectedStage.questiontype : '1'}
                                    message1={selectedStage ? selectedStage.first_message : 'Example message 1'}
                                    message2={selectedStage ? selectedStage.second_message : 'Example message 2'}
                                    message3={selectedStage ? selectedStage.final_message : 'Example message 3'}
                                    items={selectedStage ? selectedStage.questions : []}
                                    step={1}
                                    showStepper={true} />
                            </div>
                        </>
                    </ModalDialog>
                </ModalOverflow>
            </Modal>

            {loading ?
                <LoadingSpinnerComponent />
                :
                <>
                    <Alert
                        color='primary'
                        variant='soft'
                        sx={{
                            padding: 2,
                            marginBottom: configExpanded ? 2 : 0,
                        }}>
                        <div
                            className='d-flex align-items-center gap-2 cursor-pointer'
                            onClick={() => setConfigExpanded(!configExpanded)}
                            style={{ cursor: 'pointer' }}>
                            <Typography
                                level="title-sm">
                                Are you integrating Appinion with your app? Here are your credentials:
                            </Typography>
                            <Typography
                                level="body-xs">
                                (Click to {configExpanded ? 'collapse' : 'expand'})
                            </Typography>
                            <IconButton
                                size="sm"
                                variant="plain"
                                color="neutral">
                                {configExpanded ? <ExpandLess /> : <ExpandMore />}
                            </IconButton>
                        </div>
                    </Alert>

                    {configExpanded && (
                        <>
                            <Grid container spacing={2}>
                                {/* App ID Card */}
                                <Grid xs={12} md={4}>
                                    <Card
                                        color="neutral"
                                        orientation="vertical"
                                        size="lg"
                                        variant="outlined"
                                        sx={{
                                            ...cardStyles.base
                                        }}>
                                        <CardContent sx={{ flexGrow: 1 }}>
                                            <Typography level="title-sm" sx={{ fontWeight: 'bold', mb: 1 }}>
                                                App ID
                                            </Typography>
                                            <Typography level="body-xs" sx={{ mb: 2, color: 'text.secondary' }}>
                                                Unique identifier for your App. Use it in your SDK integration.
                                            </Typography>
                                            <div className='d-flex align-items-center gap-2'>
                                                <Sheet
                                                    variant='soft'
                                                    color='neutral'
                                                    sx={{
                                                        padding: '8px 12px',
                                                        borderRadius: '6px',
                                                        fontFamily: 'monospace',
                                                        fontSize: '13px',
                                                        wordBreak: 'break-all',
                                                        flexGrow: 1
                                                    }}>
                                                    {app.app.id}
                                                </Sheet>
                                                <IconButton
                                                    size="sm"
                                                    variant="soft"
                                                    color="neutral"
                                                    onClick={() => copyToClipboard(app.app.id, 'App ID')}>
                                                    <ContentCopy fontSize="small" />
                                                </IconButton>
                                            </div>
                                        </CardContent>
                                    </Card>
                                </Grid>

                                {/* API Key Card */}
                                <Grid xs={12} md={4}>
                                    <Card
                                        color="neutral"
                                        orientation="vertical"
                                        size="lg"
                                        variant="outlined"
                                        sx={{
                                            ...cardStyles.base
                                        }}>
                                        <CardContent sx={{ flexGrow: 1 }}>
                                            <Typography level="title-sm" sx={{ fontWeight: 'bold', mb: 1 }}>
                                                API Key
                                            </Typography>
                                            <Typography level="body-xs" sx={{ mb: 2, color: 'text.secondary' }}>
                                                Public key for API authentication.
                                            </Typography>
                                            <div className='d-flex align-items-center gap-2'>
                                                <Sheet
                                                    variant='soft'
                                                    color='neutral'
                                                    sx={{
                                                        padding: '8px 12px',
                                                        borderRadius: '6px',
                                                        fontFamily: 'monospace',
                                                        fontSize: '13px',
                                                        wordBreak: 'break-all',
                                                        flexGrow: 1
                                                    }}>
                                                    {configs && configs.clientId ? configs.clientId : 'Loading...'}
                                                </Sheet>
                                                <IconButton
                                                    size="sm"
                                                    variant="soft"
                                                    color="neutral"
                                                    disabled={!configs || !configs.clientId}
                                                    onClick={() => copyToClipboard(configs.clientId, 'API Key')}>
                                                    <ContentCopy fontSize="small" />
                                                </IconButton>
                                            </div>
                                        </CardContent>
                                    </Card>
                                </Grid>

                                {/* Secret Key Card */}
                                <Grid xs={12} md={4}>
                                    <Card
                                        color="neutral"
                                        orientation="vertical"
                                        size="lg"
                                        variant="outlined"
                                        sx={{
                                            ...cardStyles.base
                                        }}>
                                        <CardContent sx={{ flexGrow: 1 }}>
                                            <Typography level="title-sm" sx={{ fontWeight: 'bold', mb: 1 }}>
                                                Secret Key
                                            </Typography>
                                            <Typography level="body-xs" sx={{ mb: 2, color: 'text.secondary' }}>
                                                This is required for API authentication.
                                                Never share it publicly.
                                            </Typography>
                                            <div className='d-flex align-items-center gap-2'>
                                                <Sheet
                                                    variant='soft'
                                                    color='neutral'
                                                    sx={{
                                                        padding: '8px 12px',
                                                        borderRadius: '6px',
                                                        fontFamily: 'monospace',
                                                        fontSize: '13px',
                                                        wordBreak: 'break-all',
                                                        flexGrow: 1
                                                    }}>
                                                    {configs && configs.secretKey ? configs.secretKey : 'Loading...'}
                                                </Sheet>
                                                {configs && configs.secretKey && !configs.secretKey.includes('*') &&
                                                    <IconButton
                                                        size="sm"
                                                        variant="soft"
                                                        color="neutral"
                                                        disabled={!configs || !configs.secretKey}
                                                        onClick={() => copyToClipboard(configs.secretKey, 'Secret Key')}>
                                                        <ContentCopy fontSize="small" />
                                                    </IconButton>
                                                }
                                            </div>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>
                            <Typography
                                level="body-xs"
                                sx={{
                                    marginTop: 2,
                                }}>
                                Don't know where to start? Check our&nbsp;<Link to="https://docs.appinion.pt" className='navigation-link'>documentation</Link>.
                            </Typography>
                        </>
                    )}

                    {stages && stages.length === 0 &&
                        <Card
                            color="neutral"
                            orientation="vertical"
                            size="lg"
                            variant="outlined"
                            sx={{
                                marginTop: 2,
                                ...cardStyles.base
                            }}>

                            <div className='text-center'>
                                <EmptyMessageComponent
                                    title={'You don\'t have moments.'}
                                    description={'A moment defines when and where you ask users for feedback in your app.\
                                    It can be triggered at the end of key flows or at any meaningful interaction.'} />
                                <Button
                                    color='primary'
                                    size='sm'
                                    variant='solid'
                                    onClick={() => addNewStage(true)}
                                    sx={{
                                        marginTop: 4,
                                        maxWidth: 140
                                    }}
                                >
                                    Add a new moment
                                </Button>
                            </div>

                        </Card>
                    }

                    {stages && stages.length !== 0 &&
                        <>
                            <Typography
                                className='col mt-4'
                                level="title-sm">
                                My moments
                            </Typography>
                            {list}
                        </>
                    }
                </>
            }
        </div>
    );
}

export default FeedbackComponent;